import { BannersConfig, DeepPartial } from '@empathybroker/ebx-gluon';

export const MOBILE_BANNER_CONFIG: DeepPartial<BannersConfig> = {
  position: 'first'
};
